import { HttpClient } from '@/shared/lib/http-client';

export const createPaymentLink = async ({ orderId, amount, providerCode, paidBy, invoiceType = null, installmentTerm = null }) => {
  const response = await HttpClient.post('/orders/get-invoice', {
    orderId,
    amount,
    type: invoiceType,
    payParts: 2,
    usageMonths: null,
    installmentTerm,
    provider: providerCode,
    paidBy,
  });

  return response.data;
};